import Mirador from 'mirador/dist/es/src/index';
import {miradorImageToolsPlugin} from 'mirador-image-tools';
import canvasLinkPlugin from 'mirador-canvaslink/es';
//import downloadDialogPlugin, {getPluginConfig, translations} from 'mirador-downloaddialog/es';
import {removeCanvasInfoPlugin} from "../plugins/RemoveCanvasInfoPlugin";
import {zoomButtonPlugin} from "../plugins/ZoomButtonsPlugin";
import {removeDoubleManifestTitlePlugin} from "../plugins/RemoveDoubleManifestTitlePlugin";
import canvasNavigationPlugin from 'mirador-canvasnavigation/es';
import downloadDialogPlugin from '../plugins/download-plugin'
import process from "webpack-cli/bin/.eslintrc";
import {zoomOutOverridePlugin} from "../plugins/ZoomOutOverridePlugin";
/*
import MyCustomDownloadDialog from "./plugins/ImageLinkPlugin";
import {updateWindow} from "mirador/dist/es/src/state/actions";
import {
    getCanvasLabel,
    getContainerId,
    getManifestRelatedContent,
    getManifestUrl, getVisibleCanvases, getWindowConfig,
    selectInfoResponse,
    getVisibleCanvasNonTiledResources
} from "mirador/dist/es/src/state/selectors";

 */

const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const config = {
    // id, language, annotations and windows come from HTML options and are merged with the default config
    selectedTheme: 'onb', // Set default theme
    themes: {
        onb: {
            palette: {
                type: 'light',
                primary: {
                    main: '#C8421C',
                },
                secondary: {
                    main: '#C8421C',
                },
                text: {
                    primary: '#000000'
                },
                shades: {
                    // top bar background
                    main: '#fff',
                    // sidebar panel header
                    light: '#F5ECD8',
                    // viwer background
                    dark: '#F5F5F5'
                },
                notification: { // Color used in MUI Badge dots
                    main: '#C8421C'
                },
                // Sidebar Highlights Suche
                highlights: {
                    primary: '#FFE974', // ÖNB gelb
                    secondary: '#DFEDF0', // ÖNB blau Sammlungen sekundär
                },
                // Annotationen und Suche Farbeiinstellungen
                annotations: {
                    chipBackground: '#C8421C',
                    hidden: {globalAlpha: 0},
                    default: {strokeStyle: '#EA9A5A', globalAlpha: 1}, // ÖNB orange
                    hovered: {strokeStyle: '#DFEDF0', globalAlpha: 1},  // ÖNB blau Sammlungen sekundär
                    selected: {strokeStyle: '#FFE974', globalAlpha: 1}, // ÖNB gelb
                },
                search: {
                    default: {fillStyle: '#EA9A5A', globalAlpha: 0.5}, // ÖNB orange
                    hovered: {fillStyle: '#DFEDF0', globalAlpha: 0.5}, // ÖNB blau Sammlungen sekundär
                    selected: {fillStyle: '#FFE974', globalAlpha: 0.5}, // ÖNB gelb
                }
            },
            typography: {
                fontFamily: ['Inter', 'sans-serif'],
                // Side bar overline - ressource etc.
                overline: {
                    fontFamily: ['Spectral', 'serif'],
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '1.25rem',
                    fontStyle: 'italic',
                    letterSpacing: 'normal',
                    marginBottom: '1rem'
                },
                // Side bar overline - Titel, Person etc.
                subtitle2: {
                    fontWeight: 700,
                    fontSize: '0.8rem',
                    marginTop: '1.2rem',
                    lineHeight: '1.5rem'
                },
                // Side bar content h4 + body1- Titel, Person etc.
                h4: {
                    fontSize: '0.9rem',
                },
                body1: {
                    fontSize: '0.9rem',
                },
                caption: {
                    fontSize: '0.8rem',
                    fontWeight: 700,
                }
            },
        }
    },
    window: { //global window defaults
        allowClose: false, // Configure if windows can be closed or not
        allowFullscreen: false, // Default false - Configure to show a "fullscreen" button in the WindowTopBar
        allowMaximize: false, // Configure if windows can be maximized or not
        allowTopMenuButton: true, // Configure if window view and thumbnail display menu are visible or not
        allowWindowSideBar: true, // Configure if side bar menu is visible or not
        sideBarPanel: 'info', // Configure which sidebar is selected by default. Options: info, attribution, canvas, annotations, search
        defaultSidebarPanelHeight: 201,  // Configure default sidebar height in pixels
        defaultSidebarPanelWidth: 290, // Configure default sidebar width in pixels - default 235
        defaultView: 'single',  // Configure which viewing mode (e.g. single, book, gallery) for windows to be opened in
        hideWindowTitle: false, // Configure if the window title is shown in the window title bar or not
        highlightAllAnnotations: false, // ?? Configure whether to display annotations on the canvas by default
        showLocalePicker: false, // Configure locale picker for multi-lingual metadata
        sideBarOpen: !isMobile, // Configure if the sidebar (and its content panel) is open by default
        switchCanvasOnSearch: true, // Configure if Mirador should automatically switch to the canvas of the first search result
        panels: { // Configure which panels are visible in WindowSideBarButtons
            info: true,
            attribution: true,
            canvas: true,
            annotations: true,
            search: true,
            layers: true,
        },
        // Darstellungsoptionen - basierend auf "behavior" (paged, individuals oder continuous) im manifest wird default view gesetzt
        views: [
            // 'single' view sollte nur für behavior: 'individuals' sein, aber wegen Darstellungsfehler temporär auch für 'paged'
            {key: 'single', behaviors: ['individuals', 'paged']},
            {key: 'book', behaviors: ['paged']},
            {key: 'scroll', behaviors: ['continuous']},
            {key: 'gallery'},
        ],
        // BSB Canvas Link (Sharing) Plugin Config
        canvasLink: {
            active: true,
            enabled: true,
            singleCanvasOnly: false,
            getCanvasLink: ({manifestId, visibleCanvases}) => {
                const astorId = manifestId.split("/").slice(-1)[0];
                const canvasIndices = visibleCanvases.map(
                    (canvas) => canvas.id.split("/").slice(-1)[0],
                );
                return `${process.env.REACT_APP_VIEWER_URL}${astorId}/${canvasIndices.join(",",)}`;
            },
        },
        // BSB Canvas Navigation Plugin config
        canvasNavigation: {
            handleCanvasLabel: ({canvasLabel}) => ``,
        }
    },
    // Thumbnails default on oder off und wo sie positioniert sind
    thumbnailNavigation: {
        defaultPosition: 'far-bottom', // Which position for the thumbnail navigation to be be displayed. Other possible values are "far-bottom" or "far-right"
        displaySettings: true, // Display the settings for this in WindowTopMenu
        height: 100, // height of entire ThumbnailNavigation area when position is "far-bottom"
        width: 100, // width of one canvas (doubled for book view) in ThumbnailNavigation area when position is "far-right"
    },
    workspace: {
        showZoomControls: true, // Configure if zoom controls should be displayed by default
    },
    // Application bar anzeigen oder nicht
    workspaceControlPanel: {
        enabled: false, // Configure if the control panel should be rendered.  Useful if you want to lock the viewer down to only the configured manifests
    },
    // Übersetzungen von Viewer elementen können konfiguriert werden
    translations: {
        de: {
            rights: 'Rechtehinweise',
            attribution: 'Zuschreibung',
            related: "Verwandtes",
            aboutThisItem: "Objekt",
            resource: "Objekt",
            annotations: "Volltext",
            openCompanionWindow_annotations: "Volltext",
            showingNumAnnotations: "Der Volltext wurde automatisch generiert und könnte aufgrund von OCR-Erkennungsfehlern Ungenauigkeiten oder fehlerhafte Zeichen enthalten.",
            iiif_homepage: "Zitierlink"
        },
        en: {
            rights: 'Rights Statements',
        },
    },
}
/*
const customDialogPlugin = {
    component: MyCustomDownloadDialog,
    mode: 'wrap',
    target: 'DownloadDialogPluginArea',
    config: {
        translations,
    },
    mapDispatchToProps: (dispatch, {windowId}) => ({
        updateConfig: (downloadDialog) =>
            dispatch(updateWindow(windowId, {downloadDialog})),
    }),
    mapStateToProps: (state, {windowId}) => ({
        canvasLabel: (canvasId) => getCanvasLabel(state, {canvasId, windowId}),
        config: getPluginConfig(state, {windowId}),
        containerId: getContainerId(state),
        infoResponse: (canvasId) =>
            selectInfoResponse(state, {canvasId, windowId}) ?? {},
        manifestUrl: getManifestUrl(state, {windowId}),
        seeAlso: getManifestRelatedContent(state, {windowId}),
        visibleCanvases: getVisibleCanvases(state, {windowId}),
        nonTiledResources: getVisibleCanvasNonTiledResources(state, {windowId}),
    }),
}


 */

const plugins = [
    ...miradorImageToolsPlugin,
    zoomButtonPlugin, // add zoom buttons to Window Top Bar
    //...downloadDialogPlugin, // BSB Download Plugin
    ...canvasLinkPlugin, // BSB Plugin - Share button
    zoomOutOverridePlugin,
    ...canvasNavigationPlugin, // BSB Plugin - Navigation
    removeCanvasInfoPlugin,
    ...downloadDialogPlugin,
    removeDoubleManifestTitlePlugin
    //customDialogPlugin
]

const renderMirador = (optionsFromHTML) => {
    const mergedConfig = {...config, ...optionsFromHTML};
    return Mirador.viewer(mergedConfig, plugins);
};

export default renderMirador;
